import {
  numberToInt1ygmcfwhs2fkq as numberToInt,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  VOID3gxj6tk5isa35 as VOID,
  copyOfgossjg6lh6js as copyOf,
  Unit_instance3vdlo4e4f5ggx as Unit_instance,
  Collection1k04j3hzsbod0 as Collection,
  isInterface3d6p8outrmvmk as isInterface,
  equals2au1ep9vhcato as equals,
  KtList3hktaavzmj137 as KtList,
  StringBuildermazzzhj6kkai as StringBuilder,
  _Char___init__impl__6a9atx2yltdocdrxs4d as _Char___init__impl__6a9atx,
  protoOf180f3jzyo7rfj as protoOf,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  Char__compareTo_impl_ypi4mb1yxpplfe5vmm as Char__compareTo_impl_ypi4mb,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toString336ienavfnzn0 as toString,
  charCodeAt1yspne1d8erbm as charCodeAt,
  ArrayList3it5z8td81qkl as ArrayList,
  toList2enan2cfix0ie as toList,
  toString1pkumu07cwy4m as toString_0,
  numberToChar93r9buh19yek as numberToChar,
  RuntimeException1r3t0zl97011n as RuntimeException,
  toString30pk9tzaqopn as toString_1,
  hashCodeq5arwsb9dgti as hashCode,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  equals2v6cggk171b6e as equals_0,
  emptyList1g2z5xcrvp2zy as emptyList,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
  isCharSequence1ju9jr1w86plq as isCharSequence,
  trimEnd17pt8cbotbalj as trimEnd,
  trimStart5ewg8zf6cs5u as trimStart,
  trim11nh7r46at6sx as trim,
  sorted354mfsiv4s7x5 as sorted,
  reversed22y3au42jl32b as reversed,
  distinct10qe1scfdvu5k as distinct,
  copyToArray2j022khrow2yi as copyToArray,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  endsWith1a79dp5rc3sfv as endsWith,
  startsWith38d3sbg25w0lx as startsWith,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  substringiqarkczpya5m as substring,
  startsWith26w8qjqapeeq6 as startsWith_0,
  substringAfter1hku067gwr5ve as substringAfter,
  contains2el4s70rdq4ld as contains,
  constructCallableReference23y65rf941mch as constructCallableReference,
  to2cs3ny02qtbcb as to,
  toMap1vec9topfei08 as toMap,
  firstOrNull1982767dljvdy as firstOrNull,
  println2shhhgwwt4c61 as println,
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
  Enum3alwj03lh1n41 as Enum,
  joinToStringxqcavsxcmh4q as joinToString,
  Char19o2r8palgjof as Char,
  linkedMapOf1is69t4zkcfr3 as linkedMapOf,
  KtMap140uvy3s5zad8 as KtMap,
  substring3saq8ornu0luv as substring_0,
  toIntOrNull1j8dcc6to13o4 as toIntOrNull,
  startsWith1bgirhbedtv2y as startsWith_1,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  Regexxgw0gjiagf4z as Regex,
  sequence2vgswtrxvqoa7 as sequence,
  toList2zksu85ukrmi as toList_0,
  joinToString1cxrrlmo0chqs as joinToString_0,
  toIntOrNull3w2d066r9pvwm as toIntOrNull_0,
  toDoubleOrNullkxwozihadygj as toDoubleOrNull,
  Paire9pteg33gng7 as Pair,
  addAll1k27qatfgp3k5 as addAll,
  createThis2j2avj17cvnv2 as createThis,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
} from './kotlin-kotlin-stdlib.mjs';
import {
  DoubleList2honu8rif2roh as DoubleList,
  getAt237u54ctbxwvd as getAt,
  listIterator247sl90ooi4qv as listIterator,
  listIterator1a2ckgeamf7jc as listIterator_0,
  subList28p829u9d5w23 as subList,
  containsteg8664aaglk as contains_0,
  containsAll1oa5i6t9xmbdv as containsAll,
  isEmptyrqh4vz39e0v6 as isEmpty,
  iterator300ls4j24zqzz as iterator,
} from './korlibs-datastructure-core-root-korlibs-datastructure-core.mjs';
import {
  NumberParser_getInstance28s8v0uar5sur as NumberParser_getInstance,
  ctypeAsInt3q5txwwtaj9c8 as ctypeAsInt,
} from './korlibs-math-core-root-korlibs-math-core.mjs';
import {
  Companion_instance5ppff3ldz8y as Companion_instance,
  matchSingleOrDoubleQuoteString398sq4vhn9fz as matchSingleOrDoubleQuoteString,
  matchIdentifier3b7zgfy94bf8r as matchIdentifier,
  get_eofrk1bzx8ckgtd as get_eof,
  readUntilBuilderazvgts3bogti as readUntilBuilder,
  isWhitespaceFast2iszcfvpi3biz as isWhitespaceFast,
  skipExpect1tagjz9aj6y5q as skipExpect,
  skipSpaces25iogcdi8m3q2 as skipSpaces,
  tryExpect2a3h5rf36r8u1 as tryExpect,
} from './korlibs-string-root-korlibs-string.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class Json {
  constructor() {
    Companion_getInstance();
    this.ybn_1 = false;
  }
  gx(s) {
    return this.zbn(Companion_instance.bb6(s));
  }
  abo() {
    return this.ybn_1;
  }
  bbo(capacity) {
    return ArrayList.n2(capacity);
  }
  cbo(capacity, $super) {
    capacity = capacity === VOID ? 16 : capacity;
    return $super === VOID ? this.bbo(capacity) : $super.bbo.call(this, capacity);
  }
  dbo(doubles) {
    return toList(doubles.k9u());
  }
  zbn(s) {
    var ic = skipSpaces_0(this, s).ub5();
    var tmp;
    if (ic === _Char___init__impl__6a9atx(123)) {
      tmp = parseObject(this, s);
    } else if (ic === _Char___init__impl__6a9atx(91)) {
      tmp = parseArray(this, s);
    } else if (ic === _Char___init__impl__6a9atx(45) || (ic === _Char___init__impl__6a9atx(43) || ic === _Char___init__impl__6a9atx(48)) || (ic === _Char___init__impl__6a9atx(49) || (ic === _Char___init__impl__6a9atx(50) || ic === _Char___init__impl__6a9atx(51))) || (ic === _Char___init__impl__6a9atx(52) || (ic === _Char___init__impl__6a9atx(53) || ic === _Char___init__impl__6a9atx(54)) || (ic === _Char___init__impl__6a9atx(55) || (ic === _Char___init__impl__6a9atx(56) || ic === _Char___init__impl__6a9atx(57))))) {
      var dres = parseNumber(this, s);
      tmp = numberToInt(dres) === dres ? numberToInt(dres) : dres;
    } else if (ic === _Char___init__impl__6a9atx(116)) {
      // Inline function 'kotlin.also' call
      expect(this, s, 'true');
      tmp = true;
    } else if (ic === _Char___init__impl__6a9atx(102)) {
      // Inline function 'kotlin.also' call
      expect(this, s, 'false');
      tmp = false;
    } else if (ic === _Char___init__impl__6a9atx(110)) {
      // Inline function 'kotlin.also' call
      expect(this, s, 'null');
      tmp = null;
    } else if (ic === _Char___init__impl__6a9atx(117)) {
      // Inline function 'kotlin.also' call
      expect(this, s, 'undefined');
      tmp = null;
    } else if (ic === _Char___init__impl__6a9atx(34)) {
      tmp = this.fbo(s).toString();
    } else {
      invalidJson(this, "Not expected '" + toString(ic) + "' in " + toString_0(s));
    }
    return tmp;
  }
  ebo(_this__u8e3s4, reportErrors, out) {
    var quotec = _this__u8e3s4.vb5();
    if (quotec !== _Char___init__impl__6a9atx(34) && quotec !== _Char___init__impl__6a9atx(39))
      throw IllegalArgumentException.h2('Invalid string literal');
    var closed = false;
    loop: while (_this__u8e3s4.b6y()) {
      var c = _this__u8e3s4.vb5();
      if (c === _Char___init__impl__6a9atx(92)) {
        var cc = _this__u8e3s4.vb5();
        var tmp;
        if (cc === _Char___init__impl__6a9atx(92)) {
          tmp = _Char___init__impl__6a9atx(92);
        } else if (cc === _Char___init__impl__6a9atx(47)) {
          tmp = _Char___init__impl__6a9atx(47);
        } else if (cc === _Char___init__impl__6a9atx(39)) {
          tmp = _Char___init__impl__6a9atx(39);
        } else if (cc === _Char___init__impl__6a9atx(34)) {
          tmp = _Char___init__impl__6a9atx(34);
        } else if (cc === _Char___init__impl__6a9atx(98)) {
          tmp = _Char___init__impl__6a9atx(8);
        } else if (cc === _Char___init__impl__6a9atx(102)) {
          tmp = _Char___init__impl__6a9atx(12);
        } else if (cc === _Char___init__impl__6a9atx(110)) {
          tmp = _Char___init__impl__6a9atx(10);
        } else if (cc === _Char___init__impl__6a9atx(114)) {
          tmp = _Char___init__impl__6a9atx(13);
        } else if (cc === _Char___init__impl__6a9atx(116)) {
          tmp = _Char___init__impl__6a9atx(9);
        } else if (cc === _Char___init__impl__6a9atx(117)) {
          // Inline function 'korlibs.io.util.NumberParser.parseInt' call
          NumberParser_getInstance();
          var positive = true;
          var out_0 = 0;
          var n = 0;
          $l$loop_0: while (true) {
            var _unary__edvuaz = n;
            n = _unary__edvuaz + 1 | 0;
            var c_0 = _unary__edvuaz >= 4 ? _Char___init__impl__6a9atx(0) : _this__u8e3s4.vb5();
            if (c_0 === _Char___init__impl__6a9atx(0))
              break $l$loop_0;
            if (c_0 === _Char___init__impl__6a9atx(45) || c_0 === _Char___init__impl__6a9atx(43)) {
              positive = c_0 === _Char___init__impl__6a9atx(43);
            } else {
              var value = ctypeAsInt(c_0);
              if (value < 0)
                break $l$loop_0;
              out_0 = imul(out_0, 16);
              out_0 = out_0 + value | 0;
            }
          }
          var tmp$ret$0 = positive ? out_0 : -out_0 | 0;
          tmp = numberToChar(tmp$ret$0);
        } else {
          throw IllegalArgumentException.h2("Invalid char '" + toString(cc) + "'");
        }
        var c_1 = tmp;
        out.o1(c_1);
      } else if (c === quotec) {
        closed = true;
        break loop;
      } else
        out.o1(c);
    }
    if (!closed && reportErrors) {
      throw RuntimeException.xb("String literal not closed! '" + toString_0(_this__u8e3s4) + "'");
    }
    return out;
  }
  fbo(_this__u8e3s4, reportErrors, out, $super) {
    reportErrors = reportErrors === VOID ? true : reportErrors;
    out = out === VOID ? StringBuilder.l1() : out;
    return $super === VOID ? this.ebo(_this__u8e3s4, reportErrors, out) : $super.ebo.call(this, _this__u8e3s4, reportErrors, out);
  }
}
class Companion extends Json {
  constructor() {
    Companion_instance_0 = null;
    super();
    Companion_instance_0 = this;
  }
}
class MiniNumberArrayList {
  constructor() {
    this.gbo_1 = 0;
    this.hbo_1 = new Float64Array(16);
  }
  s2() {
    return this.gbo_1;
  }
  ibo() {
    return this.hbo_1.length;
  }
  u2(index) {
    return this.hbo_1[index];
  }
  la3(value) {
    if (this.gbo_1 >= this.ibo()) {
      this.hbo_1 = copyOf(this.hbo_1, imul(this.hbo_1.length, 3));
    }
    var tmp = this.hbo_1;
    var _unary__edvuaz = this.gbo_1;
    this.gbo_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = value;
  }
  k9u() {
    return copyOf(this.hbo_1, this.gbo_1);
  }
  g9m() {
    // Inline function 'kotlin.also' call
    var this_0 = new MiniNumberArrayList();
    this_0.gbo_1 = this.gbo_1;
    var tmp = this_0;
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.hbo_1 = this.hbo_1.slice();
    return this_0;
  }
  equals(other) {
    if (!(!(other == null) ? isInterface(other, Collection) : false))
      return false;
    if (!(other.s2() === this.gbo_1))
      return false;
    if (isInterface(other, DoubleList)) {
      var inductionVariable = 0;
      var last = this.gbo_1;
      if (inductionVariable < last)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (!(this.u2(n) === other.u2(n)))
            return false;
        }
         while (inductionVariable < last);
      return true;
    }
    if (isInterface(other, KtList)) {
      var inductionVariable_0 = 0;
      var last_0 = this.gbo_1;
      if (inductionVariable_0 < last_0)
        do {
          var n_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          if (!equals(this.u2(n_0), other.u2(n_0)))
            return false;
        }
         while (inductionVariable_0 < last_0);
      return true;
    }
    var n_1 = 0;
    var _iterator__ex2g4s = other.p1();
    while (_iterator__ex2g4s.q1()) {
      var v = _iterator__ex2g4s.r1();
      var _unary__edvuaz = n_1;
      n_1 = _unary__edvuaz + 1 | 0;
      if (!equals(this.u2(_unary__edvuaz), v))
        return false;
    }
    return true;
  }
  hashCode() {
    return contentHashCode(this, this.hbo_1, 0, this.gbo_1);
  }
  toString() {
    // Inline function 'kotlin.also' call
    var this_0 = StringBuilder.ad(2 + imul(5, this.gbo_1) | 0);
    this_0.o1(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.gbo_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(n === 0)) {
          this_0.m1(', ');
        }
        var v = this.j9u(n);
        if (numberToInt(v) === v)
          this_0.kh(numberToInt(v));
        else
          this_0.nh(v);
      }
       while (inductionVariable < last);
    this_0.o1(_Char___init__impl__6a9atx(93));
    return this_0.toString();
  }
  w2(element) {
    if (!(!(element == null) ? typeof element === 'number' : false))
      return false;
    return this.l9u((!(element == null) ? typeof element === 'number' : false) ? element : THROW_CCE());
  }
  r4(elements) {
    return this.m9u(elements);
  }
}
class Xml$Companion$parse$Level {
  constructor(children, close) {
    this.jbo_1 = children;
    this.kbo_1 = close;
  }
  toString() {
    return 'Level(children=' + toString_0(this.jbo_1) + ', close=' + toString_1(this.kbo_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.jbo_1);
    result = imul(result, 31) + (this.kbo_1 == null ? 0 : this.kbo_1.hashCode()) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Xml$Companion$parse$Level))
      return false;
    var tmp0_other_with_cast = other instanceof Xml$Companion$parse$Level ? other : THROW_CCE();
    if (!equals(this.jbo_1, tmp0_other_with_cast.jbo_1))
      return false;
    if (!equals(this.kbo_1, tmp0_other_with_cast.kbo_1))
      return false;
    return true;
  }
}
class Companion_0 {
  jbp(lits) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.n2(lits.length);
    var inductionVariable = 0;
    var last = lits.length;
    while (inductionVariable < last) {
      var item = lits[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var tmp$ret$2 = item.length;
      destination.d2(tmp$ret$2);
    }
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = distinct(reversed(sorted(destination)));
    var lengths = copyToArray(this_0);
    // Inline function 'kotlin.collections.linkedMapOf' call
    var map = LinkedHashMap.m7();
    // Inline function 'korlibs.io.serialization.xml.fastForEach' call
    var n = 0;
    while (n < lits.length) {
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.collections.set' call
      var key = lits[_unary__edvuaz];
      map.b5(key, true);
    }
    return new Literals(lits, map, lengths);
  }
}
class Element {}
class ProcessingInstructionTag extends Element {
  constructor(name, attributes) {
    super();
    this.kbp_1 = name;
    this.lbp_1 = attributes;
  }
  toString() {
    return 'ProcessingInstructionTag(name=' + this.kbp_1 + ', attributes=' + toString_0(this.lbp_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.kbp_1);
    result = imul(result, 31) + hashCode(this.lbp_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ProcessingInstructionTag))
      return false;
    var tmp0_other_with_cast = other instanceof ProcessingInstructionTag ? other : THROW_CCE();
    if (!(this.kbp_1 === tmp0_other_with_cast.kbp_1))
      return false;
    if (!equals(this.lbp_1, tmp0_other_with_cast.lbp_1))
      return false;
    return true;
  }
}
class OpenCloseTag extends Element {
  constructor(name, attributes) {
    super();
    this.obo_1 = name;
    this.pbo_1 = attributes;
  }
  toString() {
    return 'OpenCloseTag(name=' + this.obo_1 + ', attributes=' + toString_0(this.pbo_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.obo_1);
    result = imul(result, 31) + hashCode(this.pbo_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof OpenCloseTag))
      return false;
    var tmp0_other_with_cast = other instanceof OpenCloseTag ? other : THROW_CCE();
    if (!(this.obo_1 === tmp0_other_with_cast.obo_1))
      return false;
    if (!equals(this.pbo_1, tmp0_other_with_cast.pbo_1))
      return false;
    return true;
  }
}
class OpenTag extends Element {
  constructor(name, attributes) {
    super();
    this.mbo_1 = name;
    this.nbo_1 = attributes;
  }
  toString() {
    return 'OpenTag(name=' + this.mbo_1 + ', attributes=' + toString_0(this.nbo_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.mbo_1);
    result = imul(result, 31) + hashCode(this.nbo_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof OpenTag))
      return false;
    var tmp0_other_with_cast = other instanceof OpenTag ? other : THROW_CCE();
    if (!(this.mbo_1 === tmp0_other_with_cast.mbo_1))
      return false;
    if (!equals(this.nbo_1, tmp0_other_with_cast.nbo_1))
      return false;
    return true;
  }
}
class CommentTag extends Element {
  constructor(text) {
    super();
    this.zbo_1 = text;
  }
  toString() {
    return 'CommentTag(text=' + this.zbo_1 + ')';
  }
  hashCode() {
    return getStringHashCode(this.zbo_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CommentTag))
      return false;
    var tmp0_other_with_cast = other instanceof CommentTag ? other : THROW_CCE();
    if (!(this.zbo_1 === tmp0_other_with_cast.zbo_1))
      return false;
    return true;
  }
}
class CloseTag extends Element {
  constructor(name) {
    super();
    this.lbo_1 = name;
  }
  toString() {
    return 'CloseTag(name=' + this.lbo_1 + ')';
  }
  hashCode() {
    return getStringHashCode(this.lbo_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CloseTag))
      return false;
    var tmp0_other_with_cast = other instanceof CloseTag ? other : THROW_CCE();
    if (!(this.lbo_1 === tmp0_other_with_cast.lbo_1))
      return false;
    return true;
  }
}
class Text extends Element {
  constructor(text, cdata) {
    cdata = cdata === VOID ? false : cdata;
    super();
    this.vbo_1 = text;
    this.wbo_1 = cdata;
  }
  toString() {
    return 'Text(text=' + this.vbo_1 + ', cdata=' + this.wbo_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.vbo_1);
    result = imul(result, 31) + getBooleanHashCode(this.wbo_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Text))
      return false;
    var tmp0_other_with_cast = other instanceof Text ? other : THROW_CCE();
    if (!(this.vbo_1 === tmp0_other_with_cast.vbo_1))
      return false;
    if (!(this.wbo_1 === tmp0_other_with_cast.wbo_1))
      return false;
    return true;
  }
}
class Companion_1 {
  constructor() {
    this.qbo_1 = '_raw_';
    this.rbo_1 = '_text_';
    this.sbo_1 = '_cdata_';
    this.tbo_1 = '_comment_';
  }
  ubo(tagName, attributes, children) {
    var tmp = Type_NODE_getInstance();
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = LinkedHashMap.m7();
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = attributes.i3().p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      if (!(element.k3() == null)) {
        destination.b5(element.j3(), element.k3());
      }
    }
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList.n2(destination.s2());
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s_0 = destination.i3().p1();
    while (_iterator__ex2g4s_0.q1()) {
      var item = _iterator__ex2g4s_0.r1();
      var tmp$ret$7 = to(item.j3(), toString_1(item.k3()));
      destination_0.d2(tmp$ret$7);
    }
    return new Xml(tmp, tagName, toMap(destination_0), children, '');
  }
  xbo(text) {
    var tmp = Type_TEXT_getInstance();
    var tmp_0 = LinkedHashMap.m7();
    // Inline function 'kotlin.collections.listOf' call
    var tmp$ret$0 = emptyList();
    return new Xml(tmp, '_text_', tmp_0, tmp$ret$0, text);
  }
  ybo(text) {
    var tmp = Type_TEXT_getInstance();
    var tmp_0 = LinkedHashMap.m7();
    // Inline function 'kotlin.collections.listOf' call
    var tmp$ret$0 = emptyList();
    return new Xml(tmp, '_cdata_', tmp_0, tmp$ret$0, text);
  }
  abp(text) {
    var tmp = Type_COMMENT_getInstance();
    var tmp_0 = LinkedHashMap.m7();
    // Inline function 'kotlin.collections.listOf' call
    var tmp$ret$0 = emptyList();
    return new Xml(tmp, '_comment_', tmp_0, tmp$ret$0, text);
  }
  rbp(str, collapseSpaces, processNamespaces) {
    try {
      var stream = Stream_getInstance().sbp(str, collapseSpaces, processNamespaces).p1();
      var children = parse$level(stream).jbo_1;
      var tmp$ret$0;
      $l$block: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var _iterator__ex2g4s = children.p1();
        while (_iterator__ex2g4s.q1()) {
          var element = _iterator__ex2g4s.r1();
          if (element.bbp_1.equals(Type_NODE_getInstance())) {
            tmp$ret$0 = element;
            break $l$block;
          }
        }
        tmp$ret$0 = null;
      }
      var tmp0_elvis_lhs = tmp$ret$0;
      var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? firstOrNull(children) : tmp0_elvis_lhs;
      return tmp1_elvis_lhs == null ? Companion_instance_2.xbo('') : tmp1_elvis_lhs;
    } catch ($p) {
      if ($p instanceof NoSuchElementException) {
        var t = $p;
        println('ERROR: XML: ' + str + ' thrown a NoSuchElementException');
        return Companion_instance_2.xbo('!!ERRORED!!');
      } else {
        throw $p;
      }
    }
  }
}
class Type extends Enum {}
class Literals {
  constructor(lits, map, lengths) {
    this.tbp_1 = lits;
    this.ubp_1 = map;
    this.vbp_1 = lengths;
  }
  toString() {
    return 'Literals(' + joinToString(this.tbp_1, ' ') + ')';
  }
}
class Entities {
  constructor() {
    Entities_instance = this;
    this.nbp_1 = linkedMapOf([to(new Char(_Char___init__impl__6a9atx(34)), '&quot;'), to(new Char(_Char___init__impl__6a9atx(39)), '&apos;'), to(new Char(_Char___init__impl__6a9atx(60)), '&lt;'), to(new Char(_Char___init__impl__6a9atx(62)), '&gt;'), to(new Char(_Char___init__impl__6a9atx(38)), '&amp;')]);
    var tmp = this;
    var tmp_0 = Companion_instance_1;
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = this.nbp_1.y4();
    var tmp$ret$0 = copyToArray(this_0);
    tmp.obp_1 = tmp_0.jbp(tmp$ret$0);
    this.pbp_1 = flip(this.nbp_1);
  }
  wbp(str) {
    // Inline function 'korlibs.io.serialization.xml.eachBuilder' call
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.l1();
    var inductionVariable = 0;
    var last = str.length;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var it = charCodeAt(str, n);
        var entry = Entities_getInstance().nbp_1.w4(new Char(it));
        if (!(entry == null))
          this_0.m1(entry);
        else
          this_0.o1(it);
      }
       while (inductionVariable < last);
    return this_0.toString();
  }
  qbp(str) {
    return this.xbp(Companion_instance.bb6(str));
  }
  xbp(r) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.l1();
    var sb = StringBuilder.l1();
    $l$loop: while (!get_eof(r)) {
      this_0.o2(readUntilBuilder(r, _Char___init__impl__6a9atx(38), sb.sh()));
      if (get_eof(r))
        break $l$loop;
      skipExpect(r, _Char___init__impl__6a9atx(38));
      var value = readUntilBuilder(r, _Char___init__impl__6a9atx(59), sb.sh(), true);
      var full = '&' + value.toString();
      if (startsWith_1(value, _Char___init__impl__6a9atx(35))) {
        var base = 10;
        var str = value.qh(1, value.a() - 1 | 0);
        if (startsWith_0(str, 'x')) {
          base = 16;
          str = substring_0(str, 1);
        }
        var tmp42_safe_receiver = toIntOrNull(str, base);
        var tmp = tmp42_safe_receiver == null ? null : numberToChar(tmp42_safe_receiver);
        this_0.s1(tmp == null ? null : new Char(tmp));
      } else {
        // Inline function 'kotlin.collections.contains' call
        // Inline function 'kotlin.collections.containsKey' call
        var this_1 = Entities_getInstance().pbp_1;
        if ((isInterface(this_1, KtMap) ? this_1 : THROW_CCE()).u4(full))
          this_0.s1(Entities_getInstance().pbp_1.w4(full));
        else {
          this_0.m1(full);
        }
      }
    }
    return this_0.toString();
  }
}
class Stream {
  constructor() {
    Stream_instance = this;
    this.mbp_1 = Regex.hi('\\s+');
  }
  sbp(str, collapseSpaces, processNamespaces) {
    return this.ybp(Companion_instance.bb6(str), collapseSpaces, processNamespaces);
  }
  ybp(r, collapseSpaces, processNamespaces) {
    return sequence(Xml$Stream$xmlSequence$slambda(r, collapseSpaces, processNamespaces));
  }
}
class Xml {
  constructor(type, name, attributes, allChildren, content) {
    this.bbp_1 = type;
    this.cbp_1 = name;
    this.dbp_1 = attributes;
    this.ebp_1 = allChildren;
    this.fbp_1 = content;
    this.gbp_1 = toCaseInsensitiveMap(this.dbp_1);
    var tmp = this;
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.text.trim' call
    var this_0 = this.cbp_1.toLowerCase();
    tmp.hbp_1 = toString_0(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
  }
  abq() {
    // Inline function 'kotlin.collections.map' call
    var this_0 = toList_0(this.dbp_1);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.p1();
    while (_iterator__ex2g4s.q1()) {
      var item = _iterator__ex2g4s.r1();
      var tmp$ret$2 = ' ' + item.pm_1 + '="' + item.qm_1 + '"';
      destination.d2(tmp$ret$2);
    }
    return joinToString_0(destination, '');
  }
  zbp() {
    var tmp;
    switch (this.bbp_1.w1_1) {
      case 0:
        var tmp_0;
        if (this.ebp_1.n1()) {
          tmp_0 = '<' + this.cbp_1 + this.abq() + '/>';
        } else {
          var children = joinToString_0(this.ebp_1, '', VOID, VOID, VOID, VOID, Xml$_get_outerXml_$lambda_n5rc6n);
          tmp_0 = '<' + this.cbp_1 + this.abq() + '>' + children + '<\/' + this.cbp_1 + '>';
        }

        tmp = tmp_0;
        break;
      case 1:
        switch (this.cbp_1) {
          case '_text_':
            tmp = Entities_getInstance().wbp(this.fbp_1);
            break;
          case '_cdata_':
            tmp = '<![CDATA[' + this.fbp_1 + ']]>';
            break;
          case '_raw_':
            tmp = this.fbp_1;
            break;
          default:
            tmp = this.fbp_1;
            break;
        }

        break;
      case 2:
        tmp = '<!--' + this.fbp_1 + '-->';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  wi(name) {
    return this.bbq(name);
  }
  bbq(name) {
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = this.ebp_1;
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList.p2();
    var _iterator__ex2g4s = tmp0.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      if (equals_0(element.cbp_1, name, true)) {
        destination.d2(element);
      }
    }
    return destination;
  }
  cbq(name, defaultValue) {
    var tmp32_safe_receiver = this.gbp_1.w4(name);
    var tmp0_elvis_lhs = tmp32_safe_receiver == null ? null : toIntOrNull_0(tmp32_safe_receiver);
    return tmp0_elvis_lhs == null ? defaultValue : tmp0_elvis_lhs;
  }
  dbq(name, defaultValue, $super) {
    defaultValue = defaultValue === VOID ? 0 : defaultValue;
    return $super === VOID ? this.cbq(name, defaultValue) : $super.cbq.call(this, name, defaultValue);
  }
  ebq(name, defaultValue) {
    var tmp0_elvis_lhs = this.gbp_1.w4(name);
    return tmp0_elvis_lhs == null ? defaultValue : tmp0_elvis_lhs;
  }
  fbq(name, defaultValue, $super) {
    defaultValue = defaultValue === VOID ? '' : defaultValue;
    return $super === VOID ? this.ebq(name, defaultValue) : $super.ebq.call(this, name, defaultValue);
  }
  gbq(name) {
    var tmp35_safe_receiver = this.gbp_1.w4(name);
    return tmp35_safe_receiver == null ? null : toDoubleOrNull(tmp35_safe_receiver);
  }
  hbq(name) {
    return this.gbp_1.w4(name);
  }
  toString() {
    return this.zbp();
  }
  ibq(type, name, attributes, allChildren, content) {
    return new Xml(type, name, attributes, allChildren, content);
  }
  ibp(type, name, attributes, allChildren, content, $super) {
    type = type === VOID ? this.bbp_1 : type;
    name = name === VOID ? this.cbp_1 : name;
    attributes = attributes === VOID ? this.dbp_1 : attributes;
    allChildren = allChildren === VOID ? this.ebp_1 : allChildren;
    content = content === VOID ? this.fbp_1 : content;
    return $super === VOID ? this.ibq(type, name, attributes, allChildren, content) : $super.ibq.call(this, type, name, attributes, allChildren, content);
  }
  hashCode() {
    var result = this.bbp_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.cbp_1) | 0;
    result = imul(result, 31) + hashCode(this.dbp_1) | 0;
    result = imul(result, 31) + hashCode(this.ebp_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.fbp_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Xml))
      return false;
    var tmp0_other_with_cast = other instanceof Xml ? other : THROW_CCE();
    if (!this.bbp_1.equals(tmp0_other_with_cast.bbp_1))
      return false;
    if (!(this.cbp_1 === tmp0_other_with_cast.cbp_1))
      return false;
    if (!equals(this.dbp_1, tmp0_other_with_cast.dbp_1))
      return false;
    if (!equals(this.ebp_1, tmp0_other_with_cast.ebp_1))
      return false;
    if (!(this.fbp_1 === tmp0_other_with_cast.fbp_1))
      return false;
    return true;
  }
}
class CaseInsensitiveStringMap {
  constructor(mapOrig, lcToOrig, mapLC) {
    return new.target.obq(mapOrig, lcToOrig, mapLC);
  }
  static obq(mapOrig, lcToOrig, mapLC) {
    var $this = createThis(this);
    $this.jbq_1 = mapOrig;
    $this.kbq_1 = lcToOrig;
    $this.lbq_1 = mapLC;
    return $this;
  }
  n1() {
    return this.jbq_1.n1();
  }
  i3() {
    return this.jbq_1.i3();
  }
  x4() {
    return this.jbq_1.x4();
  }
  y4() {
    return this.jbq_1.y4();
  }
  s2() {
    return this.jbq_1.s2();
  }
  static mbq() {
    return this.obq(LinkedHashMap.m7(), LinkedHashMap.m7(), LinkedHashMap.m7());
  }
  u2f(key) {
    // Inline function 'kotlin.text.toLowerCase' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = key.toLowerCase();
    return this.lbq_1.u4(tmp$ret$0);
  }
  u4(key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return false;
    return this.u2f((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  }
  a5() {
    this.jbq_1.a5();
    this.lbq_1.a5();
    this.kbq_1.a5();
  }
  wi(key) {
    // Inline function 'kotlin.text.toLowerCase' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = key.toLowerCase();
    return this.lbq_1.w4(tmp$ret$0);
  }
  w4(key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    return this.wi((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  }
  pbq(key, value) {
    this.t7a(key);
    // Inline function 'kotlin.collections.set' call
    this.jbq_1.b5(key, value);
    var tmp0 = this.kbq_1;
    // Inline function 'kotlin.text.toLowerCase' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.collections.set' call
    var key_0 = key.toLowerCase();
    tmp0.b5(key_0, key);
    // Inline function 'kotlin.text.toLowerCase' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$4 = key.toLowerCase();
    return this.lbq_1.b5(tmp$ret$4, value);
  }
  b5(key, value) {
    return this.pbq((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE(), value);
  }
  nbq(from) {
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = from.i3().p1();
    while (_iterator__ex2g4s.q1()) {
      var v = _iterator__ex2g4s.r1();
      this.pbq(v.j3(), v.k3());
    }
  }
  d5(from) {
    return this.nbq(from);
  }
  t7a(key) {
    // Inline function 'kotlin.text.toLowerCase' call
    // Inline function 'kotlin.js.asDynamic' call
    var lkey = key.toLowerCase();
    var okey = this.kbq_1.w4(lkey);
    // Inline function 'kotlin.collections.remove' call
    var this_0 = this.jbq_1;
    (isInterface(this_0, KtMutableMap) ? this_0 : THROW_CCE()).c5(okey);
    var res = this.lbq_1.c5(lkey);
    this.kbq_1.c5(lkey);
    return res;
  }
  c5(key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    return this.t7a((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  }
  equals(other) {
    var tmp;
    if (other instanceof CaseInsensitiveStringMap) {
      tmp = equals(this.lbq_1, other.lbq_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.lbq_1);
  }
}
//endregion
function contentHashCode($this, $receiver, src, dst) {
  // Inline function 'korlibs.io.serialization.json.MiniNumberArrayList.hashCoder' call
  var count = dst - src | 0;
  var out = 0;
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      out = imul(out, 7);
      var tmp = out;
      out = tmp + numberToInt($receiver[src + n | 0]) | 0;
    }
     while (inductionVariable < count);
  return out;
}
var Companion_instance_0;
function Companion_getInstance() {
  if (Companion_instance_0 === VOID)
    new Companion();
  return Companion_instance_0;
}
function parseObject($this, s) {
  skipExpect_0($this, s, _Char___init__impl__6a9atx(123));
  // Inline function 'kotlin.apply' call
  var this_0 = LinkedHashMap.m7();
  obj: while (true) {
    var tmp5_subject = skipSpaces_0($this, s).ub5();
    if (tmp5_subject === _Char___init__impl__6a9atx(125)) {
      s.vb5();
      break obj;
    } else if (tmp5_subject === _Char___init__impl__6a9atx(44)) {
      s.vb5();
      continue obj;
    }
    var tmp = $this.zbn(s);
    var key = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : THROW_CCE();
    skipExpect_0($this, skipSpaces_0($this, s), _Char___init__impl__6a9atx(58));
    var value = $this.zbn(s);
    // Inline function 'kotlin.collections.set' call
    this_0.b5(key, value);
  }
  return this_0;
}
function parseArray($this, s) {
  var out = null;
  var outNumber = null;
  skipExpect_0($this, s, _Char___init__impl__6a9atx(91));
  array: while (true) {
    var tmp6_subject = skipSpaces_0($this, s).ub5();
    if (tmp6_subject === _Char___init__impl__6a9atx(93)) {
      s.vb5();
      break array;
    } else if (tmp6_subject === _Char___init__impl__6a9atx(44)) {
      s.vb5();
      continue array;
    }
    var v = s.ub5();
    if (out == null && $this.abo() && ((_Char___init__impl__6a9atx(48) <= v ? v <= _Char___init__impl__6a9atx(57) : false) || v === _Char___init__impl__6a9atx(45))) {
      if (outNumber == null) {
        outNumber = new MiniNumberArrayList();
      }
      outNumber.la3(parseNumber($this, s));
    } else {
      if (out == null) {
        var tmp7_safe_receiver = outNumber;
        var tmp0_elvis_lhs = tmp7_safe_receiver == null ? null : tmp7_safe_receiver.gbo_1;
        out = $this.bbo(tmp0_elvis_lhs == null ? 16 : tmp0_elvis_lhs);
      }
      if (!(outNumber == null)) {
        // Inline function 'korlibs.io.serialization.json.MiniNumberArrayList.fastForEach' call
        var this_0 = outNumber;
        var inductionVariable = 0;
        var last = this_0.gbo_1;
        if (inductionVariable < last)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var it = this_0.hbo_1[n];
            out.d2(it);
          }
           while (inductionVariable < last);
        outNumber = null;
      }
      out.d2($this.zbn(s));
    }
  }
  var tmp;
  if (outNumber == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = $this.dbo(outNumber);
  }
  var tmp1_elvis_lhs = tmp;
  var tmp2_elvis_lhs = tmp1_elvis_lhs == null ? out : tmp1_elvis_lhs;
  return tmp2_elvis_lhs == null ? $this.cbo() : tmp2_elvis_lhs;
}
function parseNumber($this, s) {
  // Inline function 'korlibs.io.util.NumberParser.parseDouble' call
  NumberParser_getInstance();
  var out = 0.0;
  var frac = 1.0;
  var pointSeen = false;
  var eSeen = false;
  var negate = false;
  var negateExponent = false;
  var exponent = 0;
  var n = 0;
  $l$loop: while (true) {
    n = n + 1 | 0;
    var c = s.ub5();
    var isC = Char__compareTo_impl_ypi4mb(c, _Char___init__impl__6a9atx(48)) >= 0 && Char__compareTo_impl_ypi4mb(c, _Char___init__impl__6a9atx(57)) <= 0 || c === _Char___init__impl__6a9atx(46) || c === _Char___init__impl__6a9atx(101) || c === _Char___init__impl__6a9atx(69) || c === _Char___init__impl__6a9atx(45) || c === _Char___init__impl__6a9atx(43);
    if (isC) {
      s.vb5();
    }
    var c_0 = isC ? c : _Char___init__impl__6a9atx(0);
    if (c_0 === _Char___init__impl__6a9atx(0))
      break $l$loop;
    if (c_0 === _Char___init__impl__6a9atx(101) || c_0 === _Char___init__impl__6a9atx(69))
      eSeen = true;
    else if (c_0 === _Char___init__impl__6a9atx(45)) {
      if (eSeen)
        negateExponent = true;
      else
        negate = true;
    } else if (c_0 === _Char___init__impl__6a9atx(46))
      pointSeen = true;
    else {
      if (eSeen) {
        exponent = imul(exponent, 10);
        exponent = exponent + ctypeAsInt(c_0) | 0;
      } else {
        if (pointSeen)
          frac = frac / 10;
        out = out * 10;
        out = out + ctypeAsInt(c_0);
      }
    }
  }
  var tmp = out * frac;
  // Inline function 'kotlin.math.pow' call
  var n_0 = negateExponent ? -exponent | 0 : exponent;
  var res = tmp * Math.pow(10.0, n_0);
  return negate ? -res : res;
}
function invalidJson($this, msg) {
  msg = msg === VOID ? 'Invalid JSON' : msg;
  throw IllegalArgumentException.h2(msg);
}
function expect($this, $receiver, str) {
  var inductionVariable = 0;
  var last = charSequenceLength(str) - 1 | 0;
  if (inductionVariable <= last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var c = $receiver.vb5();
      if (!(c === charCodeAt(str, n)))
        throw IllegalStateException.o("Expected '" + str + "' but found '" + toString(c) + "' at " + n);
    }
     while (inductionVariable <= last);
}
function skipSpaces_0($this, $receiver) {
  // Inline function 'korlibs.io.serialization.json.Json.skipWhile' call
  $l$loop: while (true) {
    var tmp;
    if ($receiver.b6y()) {
      var it = $receiver.ub5();
      tmp = isWhitespaceFast_0($this, it);
    } else {
      tmp = false;
    }
    if (!tmp) {
      break $l$loop;
    }
    $receiver.vb5();
  }
  return $receiver;
}
function skipExpect_0($this, $receiver, expected) {
  var readed = $receiver.vb5();
  if (!(readed === expected))
    throw IllegalArgumentException.h2("Expected '" + toString(expected) + "' but found '" + toString(readed) + "' at " + $receiver.wb5());
}
function isWhitespaceFast_0($this, $receiver) {
  return $receiver === _Char___init__impl__6a9atx(32) || $receiver === _Char___init__impl__6a9atx(9) || $receiver === _Char___init__impl__6a9atx(13) || $receiver === _Char___init__impl__6a9atx(10);
}
function parse$level(stream) {
  // Inline function 'kotlin.collections.arrayListOf' call
  var children = ArrayList.p2();
  var textNodes = 0;
  var endTag = null;
  loop: while (stream.q1()) {
    var tag = stream.r1();
    if (!(tag instanceof ProcessingInstructionTag)) {
      if (tag instanceof CommentTag)
        children.d2(Companion_instance_2.abp(tag.zbo_1));
      else {
        if (tag instanceof Text) {
          // Inline function 'kotlin.also' call
          children.d2(tag.wbo_1 ? Companion_instance_2.ybo(tag.vbo_1) : Companion_instance_2.xbo(tag.vbo_1));
          textNodes = textNodes + 1 | 0;
        } else {
          if (tag instanceof OpenCloseTag) {
            var tmp = Companion_instance_2;
            // Inline function 'kotlin.collections.listOf' call
            var tmp$ret$3 = emptyList();
            children.d2(tmp.ubo(tag.obo_1, tag.pbo_1, tmp$ret$3));
          } else {
            if (tag instanceof OpenTag) {
              var out = parse$level(stream);
              var tmp17_safe_receiver = out.kbo_1;
              var tmp18_safe_receiver = tmp17_safe_receiver == null ? null : tmp17_safe_receiver.lbo_1;
              if (!((tmp18_safe_receiver == null ? null : equals_0(tmp18_safe_receiver, tag.mbo_1, true)) === true)) {
                var tmp16_safe_receiver = out.kbo_1;
                throw IllegalArgumentException.h2("Expected '" + tag.mbo_1 + "' but was " + (tmp16_safe_receiver == null ? null : tmp16_safe_receiver.lbo_1));
              }
              children.d2(new Xml(Type_NODE_getInstance(), tag.mbo_1, tag.nbo_1, out.jbo_1, ''));
            } else {
              if (tag instanceof CloseTag) {
                endTag = tag;
                break loop;
              } else {
                noWhenBranchMatchedException();
              }
            }
          }
        }
      }
    }
  }
  // Inline function 'kotlin.collections.mapIndexed' call
  // Inline function 'kotlin.collections.mapIndexedTo' call
  var destination = ArrayList.n2(collectionSizeOrDefault(children, 10));
  var index = 0;
  var _iterator__ex2g4s = children.p1();
  while (_iterator__ex2g4s.q1()) {
    var item = _iterator__ex2g4s.r1();
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var i = checkIndexOverflow(_unary__edvuaz);
    var tmp_0;
    if (item.bbp_1.equals(Type_TEXT_getInstance())) {
      var firstText = i === 0;
      var lastText = i === (children.s2() - 1 | 0);
      var tmp_1;
      if (firstText && lastText) {
        // Inline function 'kotlin.text.trim' call
        var this_0 = item.fbp_1;
        var tmp$ret$7 = toString_0(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
        tmp_1 = item.ibp(VOID, VOID, VOID, VOID, tmp$ret$7);
      } else if (firstText) {
        // Inline function 'kotlin.text.trimStart' call
        var this_1 = item.fbp_1;
        var tmp$ret$8 = toString_0(trimStart(isCharSequence(this_1) ? this_1 : THROW_CCE()));
        tmp_1 = item.ibp(VOID, VOID, VOID, VOID, tmp$ret$8);
      } else if (lastText) {
        // Inline function 'kotlin.text.trimEnd' call
        var this_2 = item.fbp_1;
        var tmp$ret$9 = toString_0(trimEnd(isCharSequence(this_2) ? this_2 : THROW_CCE()));
        tmp_1 = item.ibp(VOID, VOID, VOID, VOID, tmp$ret$9);
      } else {
        tmp_1 = item;
      }
      tmp_0 = tmp_1;
    } else {
      tmp_0 = item;
    }
    var tmp$ret$6 = tmp_0;
    destination.d2(tmp$ret$6);
  }
  return new Xml$Companion$parse$Level(destination, endTag);
}
var Type_NODE_instance;
var Type_TEXT_instance;
var Type_COMMENT_instance;
var Type_entriesInitialized;
function Type_initEntries() {
  if (Type_entriesInitialized)
    return Unit_instance;
  Type_entriesInitialized = true;
  Type_NODE_instance = new Type('NODE', 0);
  Type_TEXT_instance = new Type('TEXT', 1);
  Type_COMMENT_instance = new Type('COMMENT', 2);
}
var Companion_instance_1;
function Companion_getInstance_0() {
  return Companion_instance_1;
}
function matchStringOrId($this, $receiver, out) {
  var tmp0_elvis_lhs = matchSingleOrDoubleQuoteString($receiver, out);
  return tmp0_elvis_lhs == null ? matchIdentifier($receiver, out) : tmp0_elvis_lhs;
}
function Xml$Stream$xmlSequence$slambda($r, $collapseSpaces, $processNamespaces) {
  return constructCallableReference(function *($this$sequence, $completion) {
    var sb = StringBuilder.ad(128);
    loop: while (!get_eof($r)) {
      var str = readUntilBuilder($r, _Char___init__impl__6a9atx(60), sb.sh(), false);
      // Inline function 'kotlin.text.isNotEmpty' call
      if (charSequenceLength(str) > 0) {
        var text = str.toString();
        var tmp;
        if ($collapseSpaces) {
          // Inline function 'kotlin.text.replace' call
          // Inline function 'kotlin.let' call
          var it = Stream_getInstance().mbp_1.mi(text, ' ');
          var tmp_0;
          var tmp$ret$4;
          $l$block: {
            // Inline function 'kotlin.text.all' call
            var inductionVariable = 0;
            while (inductionVariable < charSequenceLength(it)) {
              var element = charSequenceGet(it, inductionVariable);
              inductionVariable = inductionVariable + 1 | 0;
              if (!isWhitespaceFast(element)) {
                tmp$ret$4 = false;
                break $l$block;
              }
            }
            tmp$ret$4 = true;
          }
          if (tmp$ret$4) {
            tmp_0 = '';
          } else {
            tmp_0 = it;
          }
          tmp = tmp_0;
        } else {
          tmp = text;
        }
        var textNs = tmp;
        // Inline function 'kotlin.text.isNotEmpty' call
        if (charSequenceLength(textNs) > 0) {
          yield* $this$sequence.xm(new Text(Entities_getInstance().qbp(textNs)), $completion);
        }
      }
      if (get_eof($r))
        break loop;
      skipExpect($r, _Char___init__impl__6a9atx(60));
      skipSpaces($r);
      sb.sh();
      var processingInstruction = tryExpect($r, _Char___init__impl__6a9atx(63));
      var processingEntityOrDocType = tryExpect($r, _Char___init__impl__6a9atx(33));
      if (processingEntityOrDocType) {
        sb.o1(_Char___init__impl__6a9atx(33));
        $l$loop: while (!get_eof($r)) {
          var c = $r.ub5();
          if (c === _Char___init__impl__6a9atx(62) || isWhitespaceFast(c) || c === _Char___init__impl__6a9atx(47))
            break $l$loop;
          sb.o1($r.vb5());
          if (startsWith(sb, '!--')) {
            sb.sh();
            $l$loop_0: while (!get_eof($r)) {
              sb.o1($r.vb5());
              if (endsWith(sb, '-->')) {
                sb.uh(sb.a() - 3 | 0, sb.a());
                break $l$loop_0;
              }
            }
            yield* $this$sequence.xm(new CommentTag(sb.toString()), $completion);
            continue loop;
          }
          if (startsWith(sb, '![CDATA[')) {
            sb.sh();
            $l$loop_1: while (!get_eof($r)) {
              sb.o1($r.vb5());
              if (endsWith(sb, ']]>')) {
                sb.uh(sb.a() - 3 | 0, sb.a());
                break $l$loop_1;
              }
            }
            // Inline function 'kotlin.also' call
            var this_0 = new Text(sb.toString());
            this_0.wbo_1 = true;
            yield* $this$sequence.xm(this_0, $completion);
            continue loop;
          }
        }
        sb.th(0);
      }
      var close = tryExpect($r, _Char___init__impl__6a9atx(47)) || processingEntityOrDocType;
      skipSpaces($r);
      // Inline function 'kotlin.takeIf' call
      var tmp_1;
      // Inline function 'kotlin.text.isNotEmpty' call
      if (charSequenceLength(sb) > 0) {
        tmp_1 = sb;
      } else {
        tmp_1 = null;
      }
      var tmp43_safe_receiver = tmp_1;
      var tmp0_elvis_lhs = tmp43_safe_receiver == null ? null : tmp43_safe_receiver.toString();
      var tmp_2;
      if (tmp0_elvis_lhs == null) {
        var tmp44_safe_receiver = matchIdentifier($r, sb.sh());
        tmp_2 = tmp44_safe_receiver == null ? null : tmp44_safe_receiver.toString();
      } else {
        tmp_2 = tmp0_elvis_lhs;
      }
      var tmp1_elvis_lhs = tmp_2;
      var tmp_3;
      if (tmp1_elvis_lhs == null) {
        // Inline function 'kotlin.error' call
        var message = "Couldn't match identifier after '<', offset=" + $r.wb5() + ", near='" + $r.zb5() + "'";
        throw IllegalStateException.o(toString_0(message));
      } else {
        tmp_3 = tmp1_elvis_lhs;
      }
      var name = tmp_3;
      skipSpaces($r);
      // Inline function 'kotlin.collections.linkedMapOf' call
      var attributes = LinkedHashMap.m7();
      while (!($r.ub5() === _Char___init__impl__6a9atx(63)) && !($r.ub5() === _Char___init__impl__6a9atx(47)) && !($r.ub5() === _Char___init__impl__6a9atx(62))) {
        var tmp45_safe_receiver = matchStringOrId(Stream_getInstance(), $r, sb.sh());
        var tmp2_elvis_lhs = tmp45_safe_receiver == null ? null : tmp45_safe_receiver.toString();
        var tmp_4;
        if (tmp2_elvis_lhs == null) {
          throw IllegalArgumentException.h2('Malformed document or unsupported xml construct around ~' + $r.zb5() + "~ for name '" + name + "'");
        } else {
          tmp_4 = tmp2_elvis_lhs;
        }
        var key = tmp_4;
        skipSpaces($r);
        if (tryExpect($r, _Char___init__impl__6a9atx(61))) {
          skipSpaces($r);
          var tmp46_safe_receiver = matchStringOrId(Stream_getInstance(), $r, sb.sh());
          var argsQuote = tmp46_safe_receiver == null ? null : tmp46_safe_receiver.toString();
          // Inline function 'kotlin.collections.set' call
          var value = !(argsQuote == null) && !(startsWith_0(argsQuote, "'") || startsWith_0(argsQuote, '"')) ? argsQuote : !(argsQuote == null) ? Entities_getInstance().qbp(substring(argsQuote, 1, argsQuote.length - 1 | 0)) : Entities_getInstance().qbp(ensureNotNull(matchIdentifier($r, sb.sh())).toString());
          attributes.b5(key, value);
        } else {
          // Inline function 'kotlin.collections.set' call
          attributes.b5(key, key);
        }
        skipSpaces($r);
      }
      var openclose = tryExpect($r, _Char___init__impl__6a9atx(47));
      var processingInstructionEnd = tryExpect($r, _Char___init__impl__6a9atx(63));
      skipExpect($r, _Char___init__impl__6a9atx(62));
      var tmp_5;
      if (!$processNamespaces && contains(name, _Char___init__impl__6a9atx(58))) {
        tmp_5 = substringAfter(name, _Char___init__impl__6a9atx(58));
      } else {
        tmp_5 = name;
      }
      var elementName = tmp_5;
      yield* $this$sequence.xm(processingInstruction || processingEntityOrDocType ? new ProcessingInstructionTag(elementName, attributes) : openclose ? new OpenCloseTag(elementName, attributes) : close ? new CloseTag(elementName) : new OpenTag(elementName, attributes), $completion);
    }
    return Unit_instance;
  }, 1);
}
var Companion_instance_2;
function Companion_getInstance_1() {
  return Companion_instance_2;
}
var Entities_instance;
function Entities_getInstance() {
  if (Entities_instance === VOID)
    new Entities();
  return Entities_instance;
}
var Stream_instance;
function Stream_getInstance() {
  if (Stream_instance === VOID)
    new Stream();
  return Stream_instance;
}
function Xml$_get_outerXml_$lambda_n5rc6n(it) {
  return it.zbp();
}
function Type_NODE_getInstance() {
  Type_initEntries();
  return Type_NODE_instance;
}
function Type_TEXT_getInstance() {
  Type_initEntries();
  return Type_TEXT_instance;
}
function Type_COMMENT_getInstance() {
  Type_initEntries();
  return Type_COMMENT_instance;
}
function Xml_0(str, collapseSpaces, processNamespaces) {
  collapseSpaces = collapseSpaces === VOID ? true : collapseSpaces;
  processNamespaces = processNamespaces === VOID ? false : processNamespaces;
  return Companion_instance_2.rbp(str, collapseSpaces, processNamespaces);
}
function get(_this__u8e3s4, name) {
  return children(_this__u8e3s4, name);
}
function toCaseInsensitiveMap(_this__u8e3s4) {
  // Inline function 'kotlin.also' call
  var this_0 = CaseInsensitiveStringMap.mbq();
  this_0.nbq(_this__u8e3s4);
  return this_0;
}
function flip(_this__u8e3s4) {
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.n2(_this__u8e3s4.s2());
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = _this__u8e3s4.i3().p1();
  while (_iterator__ex2g4s.q1()) {
    var item = _iterator__ex2g4s.r1();
    var tmp$ret$3 = new Pair(item.k3(), item.j3());
    destination.d2(tmp$ret$3);
  }
  return toMap(destination);
}
function children(_this__u8e3s4, name) {
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination = ArrayList.p2();
  var _iterator__ex2g4s = _this__u8e3s4.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var list = element.bbq(name);
    addAll(destination, list);
  }
  return destination;
}
//region block: post-declaration
initMetadataForClass(Json, 'Json', Json);
initMetadataForCompanion(Companion);
protoOf(MiniNumberArrayList).j9u = getAt;
protoOf(MiniNumberArrayList).s4 = listIterator;
protoOf(MiniNumberArrayList).x2 = listIterator_0;
protoOf(MiniNumberArrayList).t4 = subList;
protoOf(MiniNumberArrayList).l9u = contains_0;
protoOf(MiniNumberArrayList).m9u = containsAll;
protoOf(MiniNumberArrayList).n1 = isEmpty;
protoOf(MiniNumberArrayList).p1 = iterator;
initMetadataForClass(MiniNumberArrayList, 'MiniNumberArrayList', MiniNumberArrayList, VOID, [DoubleList]);
initMetadataForClass(Xml$Companion$parse$Level, 'Level');
initMetadataForCompanion(Companion_0);
initMetadataForClass(Element, 'Element');
initMetadataForClass(ProcessingInstructionTag, 'ProcessingInstructionTag');
initMetadataForClass(OpenCloseTag, 'OpenCloseTag');
initMetadataForClass(OpenTag, 'OpenTag');
initMetadataForClass(CommentTag, 'CommentTag');
initMetadataForClass(CloseTag, 'CloseTag');
initMetadataForClass(Text, 'Text');
initMetadataForCompanion(Companion_1);
initMetadataForClass(Type, 'Type');
initMetadataForClass(Literals, 'Literals');
initMetadataForObject(Entities, 'Entities');
initMetadataForObject(Stream, 'Stream');
initMetadataForClass(Xml, 'Xml');
initMetadataForClass(CaseInsensitiveStringMap, 'CaseInsensitiveStringMap', CaseInsensitiveStringMap.mbq, VOID, [KtMutableMap]);
//endregion
//region block: init
Companion_instance_1 = new Companion_0();
Companion_instance_2 = new Companion_1();
//endregion
//region block: exports
export {
  Companion_getInstance as Companion_getInstanceupvgqfr8b1ba,
  Xml_0 as Xmlepssdknidwxh,
  get as get12f8xnsftqcwn,
};
//endregion
